import { toast } from '@approvalmax/ui/src/components';
import { commonErrorMessages } from 'services/error/messages';
import { isValidOcrImage } from 'shared/helpers';

/**
 * Processes the file to check if it is a valid OCR image.
 */
export const processOcrFile = async (file: File) => {
    if (!file.type.startsWith('image/')) return file;

    const url = URL.createObjectURL(file);

    try {
        const isValidImage = await isValidOcrImage(url);

        if (isValidImage) return file;

        toast.error(commonErrorMessages.ocrImageResolutionError({ fileName: file.name }));

        return null;
    } finally {
        URL.revokeObjectURL(url);
    }
};
